import { createSlice } from "@reduxjs/toolkit";

const slice = createSlice({
    name: "activeShiftSlice",
    initialState: {
        checked: false,
        onShift: false,
        pendingApproval: false,
        shift: null,
    },
    reducers: {
        SET_SHIFT_STATUS: (state, action) => {
            state.checked = true;
            state.onShift = !!action.payload?.onShift;
            state.pendingApproval = !!action.payload?.pendingApproval;
            state.shift = action.payload?.shift || null;
        },
        CLEAR_SHIFT_STATUS: (state) => {
            state.checked = false;
            state.onShift = false;
            state.pendingApproval = false;
            state.shift = null;
        },
    },
});

export const { SET_SHIFT_STATUS, CLEAR_SHIFT_STATUS } = slice.actions;
export default slice.reducer;
